import styled from "styled-components";
import RawButton from ".";

export const VButton = styled(RawButton)`
    .app-btn-sm {
        width: 154px;
        height: 36px;
        padding: var(--spacing-md) var(--spacing-lg);
        font-size: var(--font-size-text-sm);
        line-height: var(--line-height-text-sm);
        font-weight: var(--text-weight-semi-bold);
        border-radius: var(--radius-md);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-btn-md {
        max-width: 158px;
        height: 40px;
        padding: 10px 14px;
        font-size: var(--font-size-text-sm);
        line-height: var(--line-height-text-sm);
        font-weight: var(--text-weight-semi-bold);
        border-radius: var(--radius-md);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-btn-lg {
        min-width: 177px;
        height: 44px;
        padding: 10px var(--spacing-xl);
        font-size: var(--font-size-text-md);
        line-height: var(--line-height-text-md);
        font-weight: var(--text-weight-semi-bold);
        border-radius: var(--radius-md);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-btn-xl {
        width: 181px;
        height: 48px;
        padding: var(--spacing-lg) 18px;
        font-size: var(--font-size-text-md);
        line-height: var(--line-height-text-md);
        font-weight: var(--text-weight-semi-bold);
        border-radius: var(--radius-md) ;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-btn-2xl {
        width: 212px;
        height: 60px;
        padding: var(--spacing-xl) 22px;
        font-size: var(--font-size-text-lg);
        line-height: var(--line-height-text-lg);
        font-weight: var(--text-weight-semi-bold);
        border-radius: var(--radius-lg);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-btn-full {
        width: 100%;
        height: 44px;
        padding: var(--spacing-xl) 22px;
        font-size: var(--font-size-text-lg);
        line-height: var(--line-height-text-lg);
        font-weight: var(--text-weight-semi-bold);
        border-radius: var(--radius-lg);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-btn-primary{
        background-color: var(--button-primary-bg) !important;
        color: var(--button-primary-fg) !important;
        border: 1px solid var(--button-primary-bg) !important;

        &:hover{
            background-color: var(--button-primary-bg_hover) !important;
            color: var(--button-primary-fg_hover) !important;
            border: 1px solid var(--button-primary-bg_hover) !important;

        }
    }
    .app-btn-secondary{
        background-color: var(--button-secondary-bg) !important;
        color: var(--button-secondary-fg) !important;
        border: 1px solid var(--button-secondary-bg) !important;
        box-shadow: 0px 1px 2px 0px #0A0D120D !important;

        box-shadow: 0px -2px 0px 0px #0A0D120D inset !important;

        box-shadow: 0px 0px 0px 1px #0A0D122E inset !important;

        &:hover{
            background-color: var(--button-secondary-bg_hover) !important;
            color: var(--button-secondary-fg_hover);
            border: 1px solid var(--button-secondary-bg_hover) !important;

        }
    }
    .app-btn-secondary-color{
        background-color: var(--button-secondary-color-bg) !important;
        color: var(--button-secondary-color-fg) !important;
        border: 1px solid var(--button-secondary-color-border) !important;
        box-shadow: 0px 1px 2px 0px #0A0D120D !important;
        box-shadow: 0px -2px 0px 0px #0A0D120D inset !important;
        box-shadow: 0px 0px 0px 1px #0A0D122E inset !important;


        &:hover{
            background-color: var(--button-secondary-color-bg_hover);
            color: var(--button-secondary-color-fg_hover);
            border: 1px solid var(--button-secondary-color-border_hover);

        }
    }
    .app-btn-tertiary-color{
        background-color: var(--button-tertiary-color-bg) !important;
        color: var(--button-tertiary-color-fg) !important;
        border: 1px solid var(--button-tertiary-color-border) !important;
        box-shadow: 0px 1px 2px 0px #0A0D120D !important;
        box-shadow: 0px -2px 0px 0px #0A0D120D inset !important;
        box-shadow: 0px 0px 0px 1px #0A0D122E inset !important;


        &:hover{
            background-color: var(--button-tertiary-color-bg_hover) !important;
            color: var(--button-tertiary-color-fg_hover) !important;
            border: 1px solid var(--button-tertiary-color-border_hover) !important;

        }
    }
    .app-btn-danger{
        background-color: #ff4d4f !important;
        color: #ffffff !important;
        border: 1px solid #ff4d4f !important;

        &:hover{
            background-color: #ff7875 !important;
            color: #ffffff !important;
            border: 1px solid #ff7875 !important;
        }

        &:focus{
            background-color: #d9363e !important;
            color: #ffffff !important;
            border: 1px solid #d9363e !important;
        }

        &:active{
            background-color: #d9363e !important;
            color: #ffffff !important;
            border: 1px solid #d9363e !important;
        }
    }
    .app-btn-icon{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: var(--spacing-xs);
    }
`;